var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBargebase2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 21,
    viewBox: "0 0 119 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2718 4.51178C0.272873 2.85255 1.46786 0.738281 3.40458 0.738281H115.595C117.532 0.738281 118.727 2.85255 117.728 4.51178L108.626 19.6312C108.175 20.3792 107.366 20.8366 106.493 20.8366H12.5071C11.6339 20.8366 10.8246 20.3792 10.3743 19.6312L1.2718 4.51178Z",
    fill: "url(#paint0_linear_7279_78595)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7279_78595",
    x1: -11.5523,
    y1: 20.8366,
    x2: 137.235,
    y2: 20.8366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106383,
    stopColor: "#FCAA16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888889,
    stopColor: "#EF687C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBargebase2);
export default __webpack_public_path__ + "static/media/bargebase2.c5fc0b7b8afe88f9175701b0892e50aa.svg";
export { ForwardRef as ReactComponent };